import { useEffect, useState } from 'react'

export default function useOfflineMode() {
  let [online, setOnline] = useState(true)
  const handleOffline = () => setOnline(false)
  const handleOnline = () => setOnline(true)
  const handleLoad = () => setOnline(navigator.onLine)
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('load', handleLoad, false);
      window.addEventListener('online', handleOnline, false);
      window.addEventListener('offline', handleOffline, false);
      return () => {
        window.removeEventListener('load', handleLoad, false);
        window.removeEventListener('online', handleOnline, false);
        window.removeEventListener('offline', handleOffline, false);
      }
    }
  })
  return { online }
}